import { nexus } from "../../exports/nexus.js";
import { defineStore } from "../nexus/defines.js";
import { getAssignments } from "./async/getAssignments.js";
import * as asyncMappers from "./async/mappers.js";

nexus().onex.assignNamespace({
  assignments: defineStore(),
  getAssignments,
  isOnexVariant: asyncMappers.isOnexVariantAsync,
  mapOnexVariant: asyncMappers.mapOnexVariantAsync,
});
